import { Component } from '@angular/core'

@Component({
  selector: 'flowaccount-business-registration-ads-quickly-5-steps',
  templateUrl: './business-registration-ads-steps.component.html',
  styleUrl: './business-registration-ads-steps.component.scss',
})
export class BusinessRegistrationAdsStepsComponent {
  loopArray(no: number) {
    return new Array(no)
  }
}
